var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49729 1.64369C8.66592 1.21504 9.27534 1.22311 9.43256 1.65607L10.8039 5.43241C11.0095 5.99872 11.534 6.38703 12.1357 6.41839L16.3714 6.6392C16.829 6.66305 17.0162 7.23869 16.66 7.52709L13.5558 10.0409C13.1025 10.408 12.9031 11.0047 13.0447 11.5706L14.0772 15.698C14.1874 16.1388 13.6999 16.4863 13.3192 16.2382L9.81884 13.9576C9.32111 13.6333 8.67889 13.6333 8.18116 13.9576L4.68085 16.2382C4.30007 16.4863 3.81256 16.1388 3.92285 15.698L4.95532 11.5706C5.09689 11.0047 4.89751 10.408 4.44416 10.0409L1.33547 7.52345C0.979627 7.23529 1.16614 6.66012 1.62336 6.6356L5.67667 6.41827C6.2631 6.38682 6.77724 6.01605 6.99223 5.46954L8.49729 1.64369Z",
    stroke: "#D5D3E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStarOutline);
export default __webpack_public_path__ + "static/media/ico-star-outline.b007cbd8a997fddc10a1f2fb6cf7100b.svg";
export { ForwardRef as ReactComponent };